export default __webpack_public_path__ + "static/media/kerry3.808a1939.png";